<div class="abc-menu">
  @for (letter of alphabet; track letter) {
    <a
      class="abc-letter"
      [class.available]="isLetterAvailable(letter)"
      [class.active]="activeLetter() === letter"
      (click)="onLetterClick(letter)"
    >
      {{ letter }}
    </a>
  }
</div>
